import React from "react";
import { useLocalStorage } from "sprint-common-web";

import { AssetListingConfig, getDefaultAssetListingConfig } from "./AssetListingConfig";

const LISTING_CONFIG_LOCAL_STORAGE_KEY = "asset-listing-config";

export const useAssetListingConfig = () => {
    const [listingConfig, saveListingConfig] = useLocalStorage<AssetListingConfig>(
        LISTING_CONFIG_LOCAL_STORAGE_KEY,
        getDefaultAssetListingConfig()
    );

    return { listingConfig, saveListingConfig };
};
